module.exports = __webpack_public_path__ + "static/img/cursor.69715d75.svg";